<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-hxBiz-hxSkuInvFtyLocation',
  components: {
    PageTable
  }
}
</script>
